<template>
  <div class="layer">
    <div class="center-menu width">
      <el-tabs tab-position="left" v-model="currentComp" v-loading="loading">
        <el-tab-pane :label="item.name" v-for="(item,index) in menu" :key="index">
          <info :is="item.comp" :isHttp="currentComp" :isRoles="isRoles" :Kid="Kid"></info>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import info from "./menu/info";
import focus from "./menu/focus";
import permissions from "./menu/permissions";
import log from "./menu/log";
import message from "./menu/message";
import reg from "./menu/reg";
import results from "./menu/results";
import detail from "./menu/detail";
import people from "./menu/people";
import batch from "./menu/batch";
import { getAuthorizationExp } from "@/api/center";

export default {
  name: "center",
  components: {
    info,
    focus,
    permissions,
    log,
    results,
    message,
    detail,
    people,
    reg,
    batch
  },
  data() {
    return {
      menu: [], // 菜单
      roles: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).Roles
        : {}, // 权限
      currentComp: this.$route.query.data || "0",
      isRoles: true,
      loading: true,
      Kid: ""
    };
  },
  methods: {
    // 判断用户类型确定菜单栏
    setMenu() {
      let isRoles = false;
      this.roles.forEach((item, index) => {
        if (item.Id === 5 || item.Id === 6) {
          this.loading = false;
          isRoles = true;
          this.menu = [
            { name: "账户中心", comp: "info" },
            { name: "权限管理", comp: "permissions" },
            { name: "专家管理", comp: "permissions" },
            { name: "快速认领", comp: "people" }, //comp 就是 快捷模板 的方式
            { name: "批量认领", comp: "batch" } //comp 就是 快捷模板 的方式
          ];

          return true;
        }
      });
      if (!isRoles) {
        let data = {
          PageIndex: 1,
          PageSize: 24
        };
        getAuthorizationExp(data).then(res => {
          this.loading = false;
          if (res.data.Data[0]) {
            this.Kid = res.data.Data[0].ManagedExpert.KId;
            this.menu = [
              { name: "账户中心", comp: "info" },
              { name: "成果管理", comp: "results" },
              { name: "个人主页", comp: "detail" }
            ];
          } else {
            this.menu = [{ name: "账户中心", comp: "info" }];
          }
        });
      }

      this.isRoles = isRoles;
    }
  },
  watch: {},
  mounted() {
    if (!localStorage.getItem("user")) {
      this.$router.push({
        path: "/"
      });
      return;
    }
    this.setMenu();
  }
};
</script>

<style  lang="scss">
.layer {
  padding-top: 50px;
  display: flex;
  flex-direction: column;

  .center-menu {
    margin: auto;
    min-height: 75vh;
    background: #ffffff;
    .el-tabs {
      border: none;
      .el-tabs__header {
        height: 75vh;
        width: 12%;
        .el-tabs__item {
          height: 60px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/center/center.vue